document.addEventListener('DOMContentLoaded', function() {
  // Quantity increment/decrement functionality
  function setupQuantityControls() {
    // Get all quantity boxes
    const quantityBoxes = document.querySelectorAll('.adQtyBox');

    quantityBoxes.forEach(box => {
      const minusBtn = box.querySelector('.plan-needtoMinus');
      const plusBtn = box.querySelector('.plan-needtoAdd');
      const input = box.querySelector('.diet-qty');

      // Set default values based on current input values (3 for fire, 2 for water)
      if (!input.value || parseInt(input.value) === 0) {
        // Don't override the preset values (3 and 2)
        input.value = input.value || '0';
      }

      // Update button states initially
      updateButtonStates(input, plusBtn, minusBtn);
      updateOverallPlusButtonState();

      // Decrement quantity
      minusBtn.addEventListener('click', () => {
        let currentValue = parseInt(input.value);
        if (currentValue > parseInt(input.min)) {
          input.value = currentValue - 1;
          updateButtonStates(input, plusBtn, minusBtn);
          updateDietSelection();
          updateOverallPlusButtonState();
        }
      });

      // Increment quantity
      plusBtn.addEventListener('click', () => {
        let currentValue = parseInt(input.value);
        // Only increment if total quantity is less than 5 and current item is less than its max
        if (getTotalSelectedDiets() < 5 && currentValue < parseInt(input.max)) {
          input.value = currentValue + 1;
          updateButtonStates(input, plusBtn, minusBtn);
          updateDietSelection();
          updateOverallPlusButtonState();
        }
      });

      // Validate input on change
      input.addEventListener('change', () => {
        let value = parseInt(input.value);
        const minValue = parseInt(input.min);
        const maxValue = parseInt(input.max);

        if (isNaN(value) || value < minValue) {
          input.value = minValue;
        } else if (value > maxValue) {
          input.value = maxValue;
        }
        
        // Ensure that changing input directly doesn't exceed total of 5
        let totalAfterChange = getTotalSelectedDiets();
        if (totalAfterChange > 5) {
            input.value = Math.min(value, maxValue - (totalAfterChange - value));
        }

        updateButtonStates(input, plusBtn, minusBtn);
        updateDietSelection();
        updateOverallPlusButtonState();
      });
    });
  }

  // Function to update individual plus/minus button states based on current value
  function updateButtonStates(input, plusBtn, minusBtn) {
    const currentValue = parseInt(input.value);
    const maxValue = parseInt(input.max);
    const minValue = parseInt(input.min);

    // Disable minus button if current value is at its minimum
    if (currentValue <= minValue) {
      minusBtn.disabled = true;
      minusBtn.style.opacity = '0.5';
    } else {
      minusBtn.disabled = false;
      minusBtn.style.opacity = '1';
    }

    // Disable plus button if current value is at its maximum
    if (currentValue >= maxValue) {
      plusBtn.disabled = true;
      plusBtn.style.opacity = '0.5';
    } else {
      plusBtn.disabled = false;
      plusBtn.style.opacity = '1';
    }
  }

  // Function to get the total number of selected diets across all quantity boxes
  function getTotalSelectedDiets() {
    let totalSelected = 0;
    document.querySelectorAll('.diet-qty').forEach(input => {
      totalSelected += parseInt(input.value) || 0;
    });
    return totalSelected;
  }

  // Function to update the state of all plus buttons based on the total selected diets
  function updateOverallPlusButtonState() {
    const totalSelected = getTotalSelectedDiets();
    document.querySelectorAll('.plan-needtoAdd').forEach(plusBtn => {
      const input = plusBtn.closest('.adQtyBox').querySelector('.diet-qty');
      const currentValue = parseInt(input.value);
      const maxValue = parseInt(input.max);

      // Disable if total is 5, or if this specific item is already at its max
      if (totalSelected >= 5 || currentValue >= maxValue) {
        plusBtn.disabled = true;
        plusBtn.style.opacity = '0.5';
      } else {
        plusBtn.disabled = false;
        plusBtn.style.opacity = '1';
      }
    });
  }

  // Function to update selected diets based on quantities
  function updateDietSelection() {
    const dietBoxes = document.querySelectorAll('.variety-box');
    const selectedDiets = [];

    // Collect all selected diets with quantities
    dietBoxes.forEach(box => {
      const qtyInput = box.querySelector('.diet-qty');
      const qty = parseInt(qtyInput.value);
      const dietType = box.getAttribute('diet-type');

      if (qty > 0) {
        for (let i = 0; i < qty; i++) {
          selectedDiets.push(dietType);
        }
      }
    });

    // Update the hidden inputs - fill with empty strings if less than 5
    for (let i = 1; i <= 5; i++) {
      const input = document.getElementById(`diet-option-${i}`);
      if (input) {
        if (selectedDiets[i - 1]) {
          input.value = selectedDiets[i - 1];
        } else {
          input.value = '';
        }
      }
    }

    // Update the selection message
    // const totalSelected = selectedDiets.length;
    // const message = document.querySelector('.selection-message');
    // if (message) {
    //   message.textContent = `You've selected ${totalSelected} of 5 trays.`;
    // }

    // // Update the default message
    // const defaultMessage = document.querySelector('.default-message');
    // if (defaultMessage) {
    //   defaultMessage.textContent = `You've selected ${totalSelected} of 5 trays.`;
    // }

    // Enable/disable add to cart button
    const addToCartBtn = document.querySelector('.product-form__submit');
    if (addToCartBtn) {
      addToCartBtn.disabled = totalSelected !== 5;
    }
  }

  // Initialize quantity controls and set default values
  setupQuantityControls();
  // Update diet selection on load to populate hidden fields
  updateDietSelection();

  // Modal handling for diet details
  document.querySelectorAll('.diet-detail-button').forEach(button => {
    button.addEventListener('click', function() {
      const modalId = this.getAttribute('modal-id');
      document.querySelectorAll('.popup-content').forEach(content => {
        content.classList.remove('active-modal-content');
      });
      document.getElementById(modalId)?.classList.add('active-modal-content');
      document.querySelector("new-quiz-details-modal")?.classList.add("active-quiz-modal");
    });
  });

  document.querySelectorAll('.crossmodel').forEach(button => {
    button.addEventListener('click', function() {
      document.querySelectorAll('.active-modal-content').forEach(content => {
        content.classList.remove('active-modal-content');
      });
      document.querySelector("new-quiz-details-modal")?.classList.remove("active-quiz-modal");
    });
  });
});